export * from '@taqueria/protocol/out/types/VersionNumber';
